import Button from "../ui/Button/Button";

type PaginationProps = {
  page: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  resultsCount: number;
  onPageChange: (nextPage: number) => void;
};

const Pagination = ({ page, pageSize, hasNextPage, hasPreviousPage, resultsCount, onPageChange }: PaginationProps) => {
  if (!hasNextPage && !hasPreviousPage && resultsCount === 0) {
    return null;
  }

  const startResult = resultsCount === 0 ? 0 : page * pageSize + 1;
  const endResult = resultsCount === 0 ? 0 : startResult + resultsCount - 1;

  return (
    <div className="mt-4 flex flex-col items-center gap-3 rounded-xl border border-myteengig-border bg-white px-4 py-3 text-center sm:flex-row sm:justify-between sm:text-left">
      <p className="text-sm text-myteengig-text-muted">
        Showing {startResult} - {endResult}
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button
          variant="outline"
          disabled={!hasPreviousPage}
          onClick={() => onPageChange(page - 1)}
          className="disabled:opacity-50"
        >
          Previous
        </Button>
        <p className="text-sm text-myteengig-text-muted">Page {page + 1}</p>
        <Button
          variant="outline"
          disabled={!hasNextPage}
          onClick={() => onPageChange(page + 1)}
          className="disabled:opacity-50"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
